import { environment } from '../../environments/environment';

export const firebaseOptions = environment.firebase;
export const useFirebaseEmulators = environment.useEmulators;
export const firebaseEmulatorHosts = environment.emulatorHosts;
